module.exports = __webpack_public_path__ + "97e13b64e67583b61d335d9d9e67b21f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic-gift.png
// module id = 2861
// module chunks = 0